import { createApiCall } from "services/api/createApiCall";

export const getAvailableProvidersAPI = async () => {
  const response = await createApiCall({ path: "/v1/settings/invoice-providers/available", method: "GET" })();
  return response.data;
};

export const getConnectedProvidersAPI = async () => {
  const response = await createApiCall({ path: "/v1/settings/invoice-providers/connected", method: "GET" })();
  return response.data;
};

export const connectProviderAPI = async (providerId: string, configurationJson: string, isDemo: boolean) => {
  const response = await createApiCall({
    path: `/v1/settings/invoice-providers/${providerId}/connect`,
    method: "POST",
    body: { configurationJson, isDemo },
  })();
  return response.data;
};

export const disconnectProviderAPI = async (providerId: string) => {
  await createApiCall({ path: `/v1/settings/invoice-providers/${providerId}/disconnect`, method: "DELETE" })();
};

export const testProviderConnectionAPI = async (providerId: string) => {
  const response = await createApiCall({
    path: `/v1/settings/invoice-providers/${providerId}/test-connection`,
    method: "POST",
  })();
  return response.data;
};

export const setActiveOutgoingProviderAPI = async (providerId: string) => {
  await createApiCall({ path: `/v1/settings/invoice-providers/${providerId}/set-active-outgoing`, method: "PUT" })();
};

export const setActiveIncomingProviderAPI = async (providerId: string) => {
  await createApiCall({ path: `/v1/settings/invoice-providers/${providerId}/set-active-incoming`, method: "PUT" })();
};

/*---------------------------------------------------------------------------------------
  INSTALIRANE INTEGRACIJE (po tenantu)
-----------------------------------------------------------------------------------------*/

/** Šifre integracija koje je tenant instalirao. */
export const getInstalledIntegrationsAPI = async (): Promise<string[]> => {
  const response = await createApiCall({ path: "/v1/settings/integrations/installed", method: "GET" })();
  return response.data ?? [];
};

export const installIntegrationAPI = async (integrationId: string): Promise<boolean> => {
  const response = await createApiCall({
    path: `/v1/settings/integrations/${integrationId}/install`,
    method: "POST",
  })();
  return !!response.data;
};

export const uninstallIntegrationAPI = async (integrationId: string): Promise<boolean> => {
  const response = await createApiCall({
    path: `/v1/settings/integrations/${integrationId}/uninstall`,
    method: "DELETE",
  })();
  return !!response.data;
};
